import { BaseResponse } from "@/types/dto/base-response";
import { CartItemDto } from "@/types/dto/cart-item-dto";
import { AxiosInstance } from "axios";
import { baseApi } from "./base-api";

enum CartItemServiceEndpoint {
  Base = "/cart-item",
}

class CartItemService {
  private static instance: CartItemService;
  private _api: AxiosInstance;

  private constructor(api: AxiosInstance) {
    this._api = api;
  }

  static getInstance(apiClient = baseApi): CartItemService {
    if (!CartItemService.instance) {
      CartItemService.instance = new CartItemService(apiClient);
    }
    return CartItemService.instance;
  }

  async update(
    id: number,
    cartItem: Partial<CartItemDto>
  ): Promise<BaseResponse<CartItemDto, void>> {
    try {
      const response = await this._api.patch<BaseResponse<CartItemDto, void>>(
        `${CartItemServiceEndpoint.Base}/${id}`,
        cartItem
      );
      return response.data;
    } catch (error) {
      console.error("Error updating cart item:", error);
      throw error;
    }
  }
}

export const cartItemService = CartItemService.getInstance(baseApi);
